<script>
    import { FMS_BASE } from "../../utiles/fms.util.js";
    import {
        appStateStore,
        processInspectionStore,
        fetchProcessInspectionData,
        inspectionClassStore,
    } from "./store.js";
    import { onMount, onDestroy, tick } from "svelte";
    import * as api from "../../utiles/api.js";
    import toast from "svelte-french-toast";
    import { Preferences } from "@capacitor/preferences";

    let session_bplc_code = "";

    // Form Data State
    let formData = {
        prdctn_plan_no: "",
        odr: 1,
        lot_no: "",
        wrhousng_lot_no: "",
        inspct_empno: "ADMIN",
        korean_nm: "관리자",
        drw_no: "",
        date: new Date().toISOString().split("T")[0],
        end_date: new Date().toISOString().split("T")[0],
        fom: "",
        mnfctur_no: "",
        item_code: "",
        item_nm: "",
        stndrd_no: "",
        modl_no: "",
        rm: "",
        stndrd: "",
        prpert_at: "Y",
    };

    let isReadOnly = false;
    let isLatest = true;
    let hasActionSaved = false;
    let isActionProcessed = false;

    // UI State
    let verdict = "적합";
    $: formData.prpert_at = verdict === "적합" ? "Y" : "N";

    let photos = []; // { id, url, name }
    let selectedPhotoIndex = null;
    let fileInput;
    let scrollContainer;

    function scrollToTop() {
        if (scrollContainer) {
            scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
        }
    }

    // Initialization Logic
    let defectTypes = [];
    let defectCauses = [];
    let inspctIemSeCodes = [];
    let inspctIemClCodes = [];
    let inspctMthCodes = [];

    async function fetchCodes() {
        try {
            const [resTy, resCause, resSe, resCl, resMth] = await Promise.all([
                api.get("code/list?clCode=BADN_TY"),
                api.get("code/list?clCode=BADN_CAUSE"),
                api.get("code/list?clCode=INSPCT_IEM_SE"),
                api.get("code/list?clCode=INSPCT_IEM_CL"),
                api.get("code/list?clCode=INSPCT_MTH"),
            ]);
            defectTypes = (resTy?.data || []).filter((c) => c.REFRN_CODE);
            defectCauses = (resCause?.data || []).filter((c) => c.REFRN_CODE);
            inspctIemSeCodes = (resSe?.data || []).filter((c) => c.REFRN_CODE);
            inspctIemClCodes = (resCl?.data || []).filter((c) => c.REFRN_CODE);
            inspctMthCodes = (resMth?.data || []).filter((c) => c.REFRN_CODE);
        } catch (error) {
            console.error("Failed to fetch reference codes:", error);
        }
    }

    onMount(async () => {
        const { value } = await Preferences.get({ key: "retechInfo" });
        if (value) {
            const userData = JSON.parse(value);
            session_bplc_code = userData.bplc_code || "01";
        }

        fetchCodes();
        const state = $appStateStore;

        if (
            state.detailState &&
            state.detailState.selectedId === state.selectedId
        ) {
            formData = state.detailState.formData;
            detailItems = state.detailState.detailItems;
            photos = state.detailState.photos;
            isDefectPanelOpen = state.detailState.isDefectPanelOpen;
            selectedDefect = state.detailState.selectedDefect;
            selectedSubDefect = state.detailState.selectedSubDefect;
            verdict = state.detailState.verdict;
            isReadOnly = state.detailState.isReadOnly || false;
            hasActionSaved = state.detailState.hasActionSaved || false;
            isLatest = state.detailState.isLatest !== false;
            isActionProcessed = state.detailState.isActionProcessed || false;
            return;
        }

        if (state.selectedId === "new" && state.waitingData) {
            const data = state.waitingData;
            formData = {
                ...formData,
                prdctn_plan_no: data.plan_no || "",
                lot_no: data.lot_no || "",
                item_code: data.item_code || "",
                item_nm: data.item_nm || "",
                stndrd: data.stndrd || "",
                wrhousng_lot_no: data.wrhousng_lot_no || "",
                mnfctur_no: data.mnfctur_order_no || "",
                odr: data.odr || 1,
            };
            fetchStandardList(session_bplc_code || "01");
        } else if (state.selectedId !== "new" && state.selectedId !== null) {
            const item = $processInspectionStore.list.find(
                (i) => i.id === state.selectedId,
            );
            if (item) {
                isLatest = item.is_latest === "Y";
                hasActionSaved = item.has_action_saved === "Y";
                isActionProcessed = item.action_result === "조치완료" || item.action_result === "조치중";
                isReadOnly =
                    item.is_latest === "N" ||
                    (item.prpert_at === "N" && isActionProcessed);
                formData = {
                    ...formData,
                    prdctn_plan_no: item.prdctn_plan_no || "",
                    lot_no: item.lot_no || "",
                    item_code: item.item_code || "",
                    item_nm: item.item_nm || "",
                    stndrd: item.stndrd || "",
                    wrhousng_lot_no: item.wrhousng_lot_no || "",
                    mnfctur_no: item.mnfctur_no || "",
                    date: item.date || formData.date,
                    end_date: item.end_date || item.date || formData.end_date,
                    inspct_empno: item.inspct_empno || formData.inspct_empno,
                    korean_nm: item.korean_nm || formData.korean_nm,
                    prpert_at: item.prpert_at || "Y",
                    odr: item.odr || 1,
                    drw_no: item.drw_no || "",
                    stndrd_no: item.stndrd_no || "",
                    modl_no: item.modl_no || "",
                    fom: item.fom || "",
                    rm: item.rm || "",
                };
                verdict = item.prpert_at === "N" ? "부적합" : "적합";
                isInitialLoading = true;
                fetchDetailList(
                    item.bplc_code || session_bplc_code,
                    item.prdctn_plan_no,
                    item.odr,
                );
                fetchMainFile(item.prdctn_plan_no, item.odr);
            }
        }

        window.onAppBack = () => {
            if (isDefectPanelOpen) {
                isDefectPanelOpen = false;
                return true;
            }
            if (isImageZoomOpen) {
                isImageZoomOpen = false;
                return true;
            }
            if (selectedPhotoIndex !== null) {
                closeZoom();
                return true;
            }
            goBack();
            return true;
        };
    });

    onDestroy(() => {
        window.onAppBack = null;
        appStateStore.update((s) => ({
            ...s,
            detailState: {
                selectedId: s.selectedId,
                formData,
                detailItems,
                photos,
                isDefectPanelOpen,
                selectedDefect,
                selectedSubDefect,
                verdict,
                isReadOnly,
                hasActionSaved,
                isLatest,
                isActionProcessed,
            },
        }));
    });

    let detailItems = [];

    async function fetchDetailList(bplc_code, plan_no, odr) {
        try {
            const response = await api.get(
                `process-inspection/detail/list?bplc_code=${bplc_code}&prdctn_plan_no=${plan_no}&odr=${odr}`,
            );

            if (response && response.data) {
                const isArray = Array.isArray(response.data);
                const details = isArray
                    ? response.data
                    : response.data.details || [];
                const defects = isArray ? [] : response.data.defects || [];
                const defectPhotos = isArray
                    ? []
                    : response.data.defectPhotos || [];

                dbMainPhotos = defectPhotos.filter(
                    (p) =>
                        (p.INSPCT_SN || p.inspct_sn || 0) === 0 &&
                        (p.BADN_SN || p.badn_sn || 0) === 0,
                );

                detailItems = details.map((item, index) => {
                    const itemSn = item.inspct_sn;
                    const itemDefects = defects.filter(
                        (d) => (d.INSPCT_SN || d.inspct_sn) === itemSn,
                    );

                    const formattedDefects = itemDefects.map((def, defIdx) => {
                        const badnSn = def.BADN_SN || def.badn_sn;
                        const itemPhotos = defectPhotos.filter(
                            (p) =>
                                (p.INSPCT_SN || p.inspct_sn) === itemSn &&
                                (p.BADN_SN || p.badn_sn) === badnSn,
                        );

                        return {
                            id: `defect_${defIdx}_${Date.now()}`,
                            inspct_sn: itemSn,
                            badn_sn: badnSn,
                            defectType:
                                def.BADN_TY_CODE || def.badn_ty_code || "",
                            defectCause:
                                def.BADN_CAUSE_CODE ||
                                def.badn_cause_code ||
                                "",
                            defectContent: def.BADN_CN || def.badn_cn || "",
                            defectStatus:
                                (def.MANAGT_AT || def.managt_at) === "Y"
                                    ? "조치완료"
                                    : "미조치",
                            defectRm: def.RM || def.rm || "",
                            photos: itemPhotos.map((p) => ({
                                id: `db_photo_${p.PHOTO_SN || p.photo_sn}_${Math.random()}`,
                                photo_sn: p.PHOTO_SN || p.photo_sn,
                                photo_nm: p.PHOTO_NM || p.photo_nm || "",
                                rm: p.RM || p.rm || "",
                            })),
                        };
                    });

                    return {
                        ...item,
                        id: `fetched_${index}`,
                        isAdded: false,
                        defects: formattedDefects,
                    };
                });
            }
        } catch (error) {
            toast.error("상세내역을 불러오지 못했습니다.");
        } finally {
            setTimeout(() => {
                isInitialLoading = false;
                previousHasDefect = hasDefect;
            }, 500);
        }
    }

    async function fetchDefectPhotos(item, defect) {
        if (!defect.badn_sn) return;
        try {
            const params = {
                bcnc_code: "SLG00166",
                bplc_code: session_bplc_code || "01",
                menu_code: "QCM_INST_0100", // 공정검사성적서관리
                doc_no: formData.prdctn_plan_no,
                sn_1: formData.odr,
                sn_2: item.inspct_sn,
                sn_3: defect.badn_sn,
                sn_4: 0,
                sn_5: 0,
                sn_6: 0,
                sn_7: 0,
                sn_8: 0,
                sn_9: 0,
                sn_10: 0,
                target_sn_idx: 4,
            };
            const res = await api.get(
                FMS_BASE + "/api/v1/mngrfile",
                { params },
            );
            if (res && res.data) {
                const localNewPhotos = (defect.photos || []).filter(
                    (p) => p.file,
                );
                const originalPhotos = (defect.photos || []).filter(
                    (p) => !p.file,
                );

                const serverPhotos = res.data.map((f) => {
                    const matchedDbPhoto = originalPhotos.find(
                        (p) => p.photo_sn == f.sn_4,
                    );

                    return {
                        id: `photo_${f.sn_4}_${Date.now()}_${Math.random()}`,
                        url: `${FMS_BASE}/api/v1/mngrfile/display?fileNm=${f.fileNm}&filePath=${encodeURIComponent(f.filePath)}`,
                        name: f.orginlFileNm,
                        photo_nm: f.orginlFileNm,
                        photo_sn: f.sn_4,
                        file_nm: f.fileNm,
                        file_path: f.filePath,
                        rm: matchedDbPhoto ? matchedDbPhoto.rm : f.rm || "",
                        serverData: f,
                    };
                });

                defect.photos = [...serverPhotos, ...localNewPhotos];
                detailItems = detailItems;
            }
        } catch (e) {
            console.error("Failed to fetch defect photos:", e);
        }
    }

    async function fetchStandardList(bplc_code) {
        try {
            const selectedClass = $inspectionClassStore.selectedCode;
            const response = await api.get(
                `process-inspection/standard/list?bplc_code=${bplc_code}&inspct_cl_code=${selectedClass}`,
            );
            if (response && response.data) {
                detailItems = response.data.map((item, index) => ({
                    ...item,
                    id: `std_${index}`,
                    isAdded: true,
                    defects: [],
                    prpert_at: item.prpert_at || "Y",
                }));
            }
        } catch (error) {
            console.error("Error fetching standard list:", error);
            toast.error("검사항목 기준을 불러오지 못했습니다.");
        }
    }

    function openZoom(index) {
        selectedPhotoIndex = index;
    }

    function closeZoom() {
        selectedPhotoIndex = null;
    }

    function nextPhoto() {
        if (photos.length === 0) return;
        selectedPhotoIndex = (selectedPhotoIndex + 1) % photos.length;
    }

    function prevPhoto() {
        if (photos.length === 0) return;
        selectedPhotoIndex =
            (selectedPhotoIndex - 1 + photos.length) % photos.length;
    }

    function addItem(event) {
        detailItems = [
            ...detailItems,
            {
                id: Date.now(),
                delchk: "N",
                procs_no: "",
                procs_nm: "",
                inspct_iem_se_code: "",
                inspct_iem_cl_code: "",
                inspct_iem: "",
                inspct_stdr: "",
                inspct_mth_code: "",
                prpert_at: "Y",
                main_iem_at: "N",
                rm: "",
                isAdded: true,
                defects: [],
            },
        ];
        if (event && event.currentTarget) {
            event.currentTarget.blur();
        }
    }

    function removeItem(id) {
        detailItems = detailItems.filter((item) => item.id !== id);
    }

    function deleteSelectedItems() {
        detailItems = detailItems.filter((item) => item.delchk !== "Y");
    }

    function goBack() {
        appStateStore.set({
            currentView: "list",
            selectedId: null,
            waitingData: null,
            detailState: null,
        });
    }

    // 부적합 연동 로직
    $: defectiveItems = detailItems.filter((item) => item.prpert_at === "N");
    $: hasDefect = defectiveItems.length > 0;

    let isInitialLoading = false;
    let isSaving = false;
    let previousHasDefect = false;
    $: if (!isInitialLoading && hasDefect !== previousHasDefect) {
        if (hasDefect) {
            verdict = "부적합";
            formData.prpert_at = "N";
        } else {
            verdict = "적합";
            formData.prpert_at = "Y";
        }
        previousHasDefect = hasDefect;
    }

    let selectedDefect = null;
    let selectedSubDefect = null;
    let isDefectPanelOpen = false;
    let isPhotoModalOpen = false;
    let isImageZoomOpen = false;
    let zoomedImageUrl = "";

    // Pinch-to-zoom state
    let zoomScale = 1;
    let zoomTx = 0;
    let zoomTy = 0;
    let isDragging = false;
    let startX = 0,
        startY = 0;
    let initialPinchDistance = null;
    let initialScale = 1;

    function handleTouchStart(e) {
        if (e.touches.length === 2) {
            initialPinchDistance = Math.hypot(
                e.touches[0].clientX - e.touches[1].clientX,
                e.touches[0].clientY - e.touches[1].clientY,
            );
            initialScale = zoomScale;
        } else if (e.touches.length === 1 && zoomScale > 1) {
            isDragging = true;
            startX = e.touches[0].clientX - zoomTx;
            startY = e.touches[0].clientY - zoomTy;
        }
    }

    function handleTouchMove(e) {
        if (e.touches.length === 2) {
            e.preventDefault();
            const currentDistance = Math.hypot(
                e.touches[0].clientX - e.touches[1].clientX,
                e.touches[0].clientY - e.touches[1].clientY,
            );
            if (initialPinchDistance) {
                zoomScale = Math.min(
                    Math.max(
                        1,
                        initialScale * (currentDistance / initialPinchDistance),
                    ),
                    5,
                );
            }
        } else if (e.touches.length === 1 && isDragging) {
            e.preventDefault();
            zoomTx = e.touches[0].clientX - startX;
            zoomTy = e.touches[0].clientY - startY;
        }
    }

    function handleTouchEnd(e) {
        if (e.touches.length < 2) {
            initialPinchDistance = null;
        }
        if (e.touches.length === 0) {
            isDragging = false;
            if (zoomScale <= 1) {
                zoomTx = 0;
                zoomTy = 0;
            }
        }
    }

    function openImageZoom(url) {
        zoomedImageUrl = url;
        zoomScale = 1;
        zoomTx = 0;
        zoomTy = 0;
        isImageZoomOpen = true;
    }

    $: if (
        selectedDefect &&
        !defectiveItems.find((i) => i.id === selectedDefect.id)
    ) {
        selectedDefect = null;
    }

    $: if (!hasDefect && isDefectPanelOpen) {
        isDefectPanelOpen = false;
    }

    function triggerDefectFileInput(id) {
        const el = document.getElementById(`file_defect_${id}`);
        if (el) el.click();
    }

    function triggerDefectCameraInput(id) {
        const el = document.getElementById(`camera_defect_${id}`);
        if (el) el.click();
    }

    function handleDefectFileChange(event, item) {
        const files = Array.from(event.target.files);
        const newPhotos = files.map((file) => ({
            id: Math.random().toString(36).substr(2, 9),
            url: URL.createObjectURL(file),
            name: file.name,
            file: file,
            delchk: "N",
        }));
        if (!item.photos) item.photos = [];
        item.photos = [...item.photos, ...newPhotos];
        detailItems = detailItems;
        event.target.value = null;
    }

    function deleteSelectedDefectPhotos() {
        if (!selectedSubDefect || !selectedSubDefect.photos) return;
        selectedSubDefect.photos = selectedSubDefect.photos.filter(
            (p) => p.delchk !== "Y",
        );
        detailItems = detailItems;
    }

    function addDefectRow() {
        if (!selectedDefect) return;
        if (!selectedDefect.defects) selectedDefect.defects = [];
        selectedDefect.defects = [
            ...selectedDefect.defects,
            {
                id: Math.random().toString(36).substr(2, 9),
                delchk: "N",
                defectType: "",
                defectCause: "",
                defectContent: "",
                defectStatus: "미조치",
                defectRm: "",
                photos: [],
            },
        ];
        detailItems = detailItems;
    }

    function deleteSelectedDefectRows() {
        if (!selectedDefect || !selectedDefect.defects) return;
        selectedDefect.defects = selectedDefect.defects.filter(
            (d) => d.delchk !== "Y",
        );
        detailItems = detailItems;
    }

    function toggleRowSelection(event, item) {
        const tag = event.target.tagName.toLowerCase();
        if (
            tag === "input" ||
            tag === "select" ||
            tag === "button" ||
            tag === "textarea"
        ) {
            return;
        }
        item.delchk = item.delchk === "Y" ? "N" : "Y";
        detailItems = detailItems;
    }

    let mainFiles = [];
    let dbMainPhotos = [];
    let isMainFileModalOpen = false;
    let mainCameraInput;
    let mainGalleryInput;

    function triggerMainCameraInput() {
        if (mainCameraInput) mainCameraInput.click();
    }

    function triggerMainGalleryInput() {
        if (mainGalleryInput) mainGalleryInput.click();
    }

    function handleMainFilesChange(event) {
        const files = Array.from(event.target.files);
        const newFiles = files.map((file) => ({
            id: Math.random().toString(36).substr(2, 9),
            url: URL.createObjectURL(file),
            name: file.name,
            file: file,
            delchk: "N",
            rm: "",
        }));
        mainFiles = [...mainFiles, ...newFiles];
        event.target.value = null;
    }

    function deleteSelectedMainFiles() {
        mainFiles = mainFiles.filter((p) => p.delchk !== "Y");
    }

    async function fetchMainFile(plan_no, odr) {
        try {
            const params = {
                bcnc_code: "SLG00166",
                bplc_code: session_bplc_code || "01",
                menu_code: "QCM_INST_0100",
                doc_no: plan_no,
                sn_1: odr,
                sn_2: 0,
                sn_3: 0,
                sn_4: 0,
                sn_5: 0,
                sn_6: 0,
                sn_7: 0,
                sn_8: 0,
                sn_9: 0,
                sn_10: 0,
                target_sn_idx: 2,
            };
            const res = await api.get(
                FMS_BASE + "/api/v1/mngrfile",
                { params },
            );
            if (res && res.data) {
                mainFiles = res.data.map((f) => {
                    const matchedDbPhoto = dbMainPhotos.find(
                        (p) => (p.PHOTO_SN || p.photo_sn) == f.sn_4,
                    );
                    return {
                        id: `main_photo_${f.sn_4}_${Date.now()}_${Math.random()}`,
                        url: `${FMS_BASE}/api/v1/mngrfile/display?fileNm=${f.fileNm}&filePath=${encodeURIComponent(f.filePath)}`,
                        name: f.orginlFileNm,
                        photo_nm: f.orginlFileNm,
                        photo_sn: f.sn_4,
                        file_nm: f.fileNm,
                        file_path: f.filePath,
                        rm: matchedDbPhoto
                            ? matchedDbPhoto.RM || matchedDbPhoto.rm || ""
                            : f.rm || "",
                        delchk: "N",
                        serverData: f,
                    };
                });
            }
        } catch (e) {
            console.error("Failed to fetch main files:", e);
        }
    }

    function openFile(file, serverData) {
        if (file) {
            const url = URL.createObjectURL(file);
            const ext = (file.name || "").split(".").pop().toLowerCase();
            const imgExts = ["jpg", "jpeg", "png", "gif", "bmp"];
            if (imgExts.includes(ext)) {
                openImageZoom(url);
            } else {
                window.open(url, "_blank");
            }
        } else if (serverData) {
            const ext = serverData.fileNm.split(".").pop().toLowerCase();
            const imgExts = ["jpg", "jpeg", "png", "gif", "bmp"];

            if (imgExts.includes(ext)) {
                const viewUrl = `${FMS_BASE}/api/v1/mngrfile/display?fileNm=${serverData.fileNm}&filePath=${encodeURIComponent(serverData.filePath)}`;
                openImageZoom(viewUrl);
            } else if (ext === "pdf") {
                const viewUrl = `${FMS_BASE}/api/v1/mngrfile/display?fileNm=${serverData.fileNm}&filePath=${encodeURIComponent(serverData.filePath)}`;
                window.open(viewUrl, "_blank");
            } else {
                const downloadUrl = `${FMS_BASE}/api/v1/mngrfile/download?fileNm=${serverData.fileNm}&orginlFileNm=${serverData.orginlFileNm}&filePath=${encodeURIComponent(serverData.filePath)}`;
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("target", "_self");
                link.click();
                toast.success("다운로드를 요청했습니다.");
            }
        }
    }

    async function save() {
        isSaving = true;
        const flattenedDefects = [];
        const flattenedPhotos = [];

        if (mainFiles && mainFiles.length > 0) {
            mainFiles.forEach((file, pIdx) => {
                flattenedPhotos.push({
                    bplc_code: session_bplc_code || "01",
                    prdctn_plan_no: formData.prdctn_plan_no,
                    odr: formData.odr,
                    inspct_sn: 0,
                    badn_sn: 0,
                    photo_sn: pIdx + 1,
                    photo_nm: file.photo_nm || file.name || "",
                    rm: file.rm || "",
                    register: formData.inspct_empno,
                    updusr: formData.inspct_empno,
                });
            });
        }

        detailItems.forEach((item, iIdx) => {
            const inspctSn = item.inspct_sn || iIdx + 1;
            if (item.prpert_at === "N" && item.defects && item.defects.length > 0) {
                item.defects.forEach((defect, dIdx) => {
                    const badnSn = dIdx + 1;
                    flattenedDefects.push({
                        bplc_code: session_bplc_code || "01",
                        prdctn_plan_no: formData.prdctn_plan_no,
                        odr: formData.odr,
                        inspct_sn: inspctSn,
                        badn_sn: badnSn,
                        badn_ty_code: defect.defectType || "",
                        badn_cause_code: defect.defectCause || "",
                        badn_cn: defect.defectContent || "",
                        managt_at:
                            defect.defectStatus === "조치완료" ? "Y" : "N",
                        rm: defect.defectRm || "",
                        register: formData.inspct_empno,
                        updusr: formData.inspct_empno,
                    });

                    if (defect.photos && defect.photos.length > 0) {
                        defect.photos.forEach((photo, pIdx) => {
                            flattenedPhotos.push({
                                bplc_code: session_bplc_code || "01",
                                prdctn_plan_no: formData.prdctn_plan_no,
                                odr: formData.odr,
                                inspct_sn: inspctSn,
                                badn_sn: badnSn,
                                photo_sn: pIdx + 1,
                                photo_nm: photo.photo_nm || photo.name || "",
                                rm: photo.rm || "",
                                register: formData.inspct_empno,
                                updusr: formData.inspct_empno,
                            });
                        });
                    }
                });
            }
        });

        const mappedDetails = detailItems.map((item, idx) => ({
            ...item,
            bplc_code: session_bplc_code || "01",
            prdctn_plan_no: formData.prdctn_plan_no,
            odr: formData.odr,
            inspct_sn: item.inspct_sn || idx + 1,
            main_iem_at: item.main_iem_at || "N",
            register: formData.inspct_empno,
            updusr: formData.inspct_empno,
        }));

        const payload = {
            ...formData,
            prpert_at: verdict === "적합" ? "Y" : "N",
            detailItems: mappedDetails,
            defects: flattenedDefects,
            photos: flattenedPhotos,
        };

        const loadingToast = toast.loading(
            "데이터를 저장하는 중입니다. 잠시만 기다려주세요...",
        );
        try {
            const res = await api.postJson("process-inspection/save", payload);
            if (res.code === 200) {
                await uploadMainFiles();
                await uploadAllDefectPhotos();
                toast.dismiss(loadingToast);
                toast.success("성공적으로 저장되었습니다.");
                await fetchProcessInspectionData(session_bplc_code, true);

                // 리스트로 돌아가지 않고 현재 수정한/등록한 상세 화면에 머무르도록 상태 새로고침
                const savedId = formData.prdctn_plan_no + "_" + formData.odr;
                appStateStore.set({
                    currentView: "list",
                    selectedId: null,
                    waitingData: null,
                    detailState: null,
                });
                tick().then(() => {
                    const item = $processInspectionStore.list.find(
                        (i) => i.id === savedId,
                    );
                    processInspectionStore.update((s) => ({
                        ...s,
                        selectedItem: item,
                    }));
                    appStateStore.set({
                        currentView: "detail",
                        selectedId: savedId,
                        waitingData: null,
                        detailState: null,
                    });
                });
            } else {
                toast.dismiss(loadingToast);
                toast.error("저장 실패: " + res.msg);
            }
        } catch (e) {
            console.error("Save error:", e);
            toast.dismiss(loadingToast);
            toast.error("저장 중 오류가 발생했습니다.");
        } finally {
            isSaving = false;
        }
    }

    async function deleteFmsFiles() {
        try {
            // 1. 주 내역 첨부파일 삭제 (target_sn_idx = 2)
            const mainFormData = new FormData();
            mainFormData.append("bcnc_code", "SLG00166");
            mainFormData.append("bplc_code", session_bplc_code || "01");
            mainFormData.append("menu_code", "QCM_INST_0100");
            mainFormData.append("doc_no", formData.prdctn_plan_no);
            mainFormData.append("register", formData.inspct_empno);
            mainFormData.append("updusr", formData.inspct_empno);
            mainFormData.append("sn_1", formData.odr);
            mainFormData.append("sn_2", 0);
            mainFormData.append("sn_3", 0);
            mainFormData.append("sn_4", 0);
            for (let i = 5; i <= 10; i++) {
                mainFormData.append(`sn_${i}`, 0);
            }
            mainFormData.append("target_sn_idx", 2);
            mainFormData.append("reInsertListJson", "[]");

            await api.post(
                FMS_BASE + "/api/v1/mngrfile",
                mainFormData,
            );

            // 2. 불량 내역 첨부파일 삭제 (target_sn_idx = 4)
            for (let i = 0; i < detailItems.length; i++) {
                const item = detailItems[i];
                const inspct_sn = item.inspct_sn || i + 1;
                if (item.defects && item.defects.length > 0) {
                    for (let j = 0; j < item.defects.length; j++) {
                        const defect = item.defects[j];
                        const badn_sn = j + 1;
                        
                        const defectFormData = new FormData();
                        defectFormData.append("bcnc_code", "SLG00166");
                        defectFormData.append("bplc_code", session_bplc_code || "01");
                        defectFormData.append("menu_code", "QCM_INST_0100");
                        defectFormData.append("doc_no", formData.prdctn_plan_no);
                        defectFormData.append("register", formData.inspct_empno);
                        defectFormData.append("updusr", formData.inspct_empno);
                        defectFormData.append("sn_1", formData.odr);
                        defectFormData.append("sn_2", inspct_sn);
                        defectFormData.append("sn_3", badn_sn);
                        defectFormData.append("sn_4", 0);
                        for (let k = 5; k <= 10; k++) {
                            defectFormData.append(`sn_${k}`, 0);
                        }
                        defectFormData.append("target_sn_idx", 4);
                        defectFormData.append("reInsertListJson", "[]");

                        await api.post(
                            FMS_BASE + "/api/v1/mngrfile",
                            defectFormData,
                        );
                    }
                }
            }
        } catch (e) {
            console.error("Failed to delete FMS files:", e);
        }
    }

    async function deleteInspection() {
        if (hasActionSaved) {
            toast.error("조치 내역 또는 조치 사진이 등록되어 있어 삭제할 수 없습니다.");
            return;
        }
        if (!confirm("정말 이 공정검사 성적서를 삭제하시겠습니까?\n삭제된 데이터는 복구할 수 없습니다.")) {
            return;
        }

        isSaving = true;
        const loadingToast = toast.loading(
            "데이터를 삭제하는 중입니다. 잠시만 기다려주세요...",
        );
        try {
            // FMS 파일 삭제 요청 우선 진행
            await deleteFmsFiles();

            const payload = {
                bplc_code: session_bplc_code || "01",
                prdctn_plan_no: formData.prdctn_plan_no,
                odr: formData.odr,
                updusr: formData.inspct_empno,
            };
            const res = await api.postJson("process-inspection/delete", payload);
            if (res && res.code === 200) {
                toast.dismiss(loadingToast);
                toast.success("성공적으로 삭제되었습니다.");
                await fetchProcessInspectionData(session_bplc_code, true);
                goBack();
            } else {
                toast.dismiss(loadingToast);
                toast.error("삭제 실패: " + (res?.msg || "알 수 없는 오류"));
            }
        } catch (e) {
            console.error("Delete error:", e);
            toast.dismiss(loadingToast);
            toast.error("삭제 중 오류가 발생했습니다.");
        } finally {
            isSaving = false;
        }
    }

    async function uploadMainFiles() {
        const newFiles = mainFiles.filter((p) => p.file);
        const currentServerFiles = mainFiles.filter((p) => !p.file);

        const formDataFile = new FormData();
        formDataFile.append("bcnc_code", "SLG00166");
        formDataFile.append("bplc_code", session_bplc_code);
        formDataFile.append("menu_code", "QCM_INST_0100");
        formDataFile.append("doc_no", formData.prdctn_plan_no);
        formDataFile.append("register", formData.inspct_empno);
        formDataFile.append("updusr", formData.inspct_empno);

        formDataFile.append("sn_1", formData.odr);
        formDataFile.append("sn_2", 0);
        formDataFile.append("sn_3", 0);
        formDataFile.append("sn_4", 0);
        formDataFile.append("sn_5", 0);
        formDataFile.append("sn_6", 0);
        formDataFile.append("sn_7", 0);
        formDataFile.append("sn_8", 0);
        formDataFile.append("sn_9", 0);
        formDataFile.append("sn_10", 0);

        formDataFile.append("target_sn_idx", 2);

        newFiles.forEach((p) => {
            formDataFile.append("uploadFiles", p.file);
        });

        const mappedReInsert = currentServerFiles.map((p) => ({
            sn_1: formData.odr,
            sn_2: 0,
            sn_3: 0,
            sn_4: p.photo_sn || p.serverData?.sn_4 || 0,
            fileNm: p.file_nm || p.fileNm || p.serverData?.fileNm,
            filePath: p.file_path || p.filePath || p.serverData?.filePath,
            orginlFileNm: p.photo_nm || p.name || p.serverData?.orginlFileNm,
        }));
        formDataFile.append("reInsertListJson", JSON.stringify(mappedReInsert));

        try {
            await api.post(
                FMS_BASE + "/api/v1/mngrfile",
                formDataFile,
            );
        } catch (e) {
            console.error("Main Files Upload Error:", e);
            throw e;
        }
    }

    async function uploadAllDefectPhotos() {
        for (let i = 0; i < detailItems.length; i++) {
            const item = detailItems[i];
            const inspct_sn = item.inspct_sn || i + 1;
            if (item.defects && item.defects.length > 0) {
                for (let j = 0; j < item.defects.length; j++) {
                    const defect = item.defects[j];
                    const badn_sn = j + 1;
                    if (defect.photos && defect.photos.length > 0) {
                        let currentServerPhotos = defect.photos
                            .filter((p) => p.serverData)
                            .map((p) => p.serverData);
                        const newPhotos = defect.photos.filter((p) => p.file);
                        if (newPhotos.length > 0) {
                            await uploadDefectPhotosBatch(
                                inspct_sn,
                                badn_sn,
                                newPhotos,
                                defect.photos,
                                currentServerPhotos,
                            );
                        }
                    }
                }
            }
        }
    }

    async function uploadDefectPhotosBatch(
        inspct_sn,
        badn_sn,
        newPhotos,
        allPhotos,
        reInsertList,
    ) {
        const formDataFile = new FormData();
        formDataFile.append("bcnc_code", "SLG00166");
        formDataFile.append("bplc_code", session_bplc_code);
        formDataFile.append("menu_code", "QCM_INST_0100");
        formDataFile.append("doc_no", formData.prdctn_plan_no);
        formDataFile.append("register", formData.inspct_empno);
        formDataFile.append("updusr", formData.inspct_empno);
        formDataFile.append("sn_1", formData.odr);
        formDataFile.append("sn_2", inspct_sn);
        formDataFile.append("sn_3", badn_sn);
        formDataFile.append("sn_4", 0);
        for (let i = 5; i <= 10; i++) {
            formDataFile.append(`sn_${i}`, 0);
        }
        newPhotos.forEach((p) => {
            formDataFile.append("uploadFiles", p.file);
        });
        formDataFile.append("target_sn_idx", 4);
        formDataFile.append("reInsertListJson", JSON.stringify(reInsertList));

        try {
            await api.post(
                FMS_BASE + "/api/v1/mngrfile",
                formDataFile,
            );
        } catch (e) {
            console.error("Defect Photos Batch Upload Error:", e);
        }
    }
</script>

<div class="detail-page-container">
    {#if isSaving}
        <div class="loading-overlay">
            <div class="loading-spinner"></div>
            <p>데이터를 저장하는 중입니다. 잠시만 기다려주세요...</p>
        </div>
    {/if}
    {#if !isDefectPanelOpen}
        <header class="top-bar">
            <div class="header-left">
                <button class="icon-btn" on:click={goBack}>
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.5"
                    >
                        <path d="m15 18-6-6 6-6" />
                    </svg>
                </button>
                <h1 class="title">공정검사 조회</h1>
            </div>
            <div class="header-right">
                <button
                    class="btn btn-secondary"
                    on:click={scrollToTop}
                    style="margin-right: 8px; font-weight: 700; border-radius: 8px;"
                >
                    ↑ 맨위로
                </button>
                {#if isLatest && $appStateStore.selectedId !== 'new' && $appStateStore.selectedId !== null && !isActionProcessed}
                    <button 
                        class="btn btn-delete" 
                        class:disabled={hasActionSaved}
                        on:click={deleteInspection}
                    >
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2.5"
                            style="margin-right: 2px;"
                        >
                            <polyline points="3 6 5 6 21 6" />
                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                        </svg>
                        <span>삭제하기</span>
                    </button>
                {/if}
                {#if !isReadOnly}
                    <button class="btn btn-primary btn-save" on:click={save}>
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2.5"
                        >
                            <path
                                d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
                            />
                            <polyline points="17 21 17 13 7 13 7 21" />
                            <polyline points="7 3 7 8 15 8" />
                        </svg>
                        <span>전체 저장하기</span>
                    </button>
                {/if}
            </div>
        </header>

        <main class="content-scroll" bind:this={scrollContainer}>
            <section class="section-card">
                <div
                    style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;"
                >
                    <h2 class="section-title" style="margin-bottom: 0;">
                        ▣ 주 내역
                    </h2>
                    <div style="display: flex; gap: 8px;">
                        <button
                            class="btn btn-secondary btn-sm"
                            style="background-color: #f8f9fa; color: #495057; border: 1px solid #ced4da; font-weight: bold;"
                            on:click={() => (isMainFileModalOpen = true)}
                        >
                            📎 첨부파일 {mainFiles && mainFiles.length > 0
                                ? `(${mainFiles.length}건)`
                                : ""}
                        </button>
                    </div>
                </div>
                <div class="form-grid">
                    <div class="form-group required">
                        <label>생산계획번호</label>
                        <input
                            type="text"
                            placeholder="입력"
                            bind:value={formData.prdctn_plan_no}
                            disabled
                        />
                    </div>
                    <div class="form-group required">
                        <label>회차</label>
                        <input
                            type="number"
                            placeholder="입력"
                            bind:value={formData.odr}
                            disabled
                        />
                    </div>
                    <div class="form-group required">
                        <label>LOT NO</label>
                        <input
                            type="text"
                            placeholder="입력"
                            bind:value={formData.lot_no}
                            disabled
                        />
                    </div>
                    <div class="form-group">
                        <label>ERP LOT NO</label>
                        <input
                            type="text"
                            placeholder="입력"
                            bind:value={formData.wrhousng_lot_no}
                            disabled
                        />
                    </div>
                    <div class="form-group required">
                        <label>검사자 사번 / 성명</label>
                        <div style="display: flex; gap: 8px;">
                            <input
                                type="text"
                                placeholder="사번"
                                style="flex: 1;"
                                bind:value={formData.inspct_empno}
                                disabled
                            />
                            <input
                                type="text"
                                placeholder="성명"
                                style="flex: 1;"
                                bind:value={formData.korean_nm}
                                disabled
                            />
                        </div>
                    </div>
                    <div class="form-group">
                        <label>도면번호</label>
                        <input
                            type="text"
                            placeholder="입력"
                            bind:value={formData.drw_no}
                            disabled={isReadOnly}
                        />
                    </div>
                    <div class="form-group required">
                        <label>검사시작일</label>
                        <input
                            type="date"
                            bind:value={formData.date}
                            disabled={isReadOnly}
                        />
                    </div>
                    <div class="form-group required">
                        <label>검사종료일</label>
                        <input
                            type="date"
                            bind:value={formData.end_date}
                            disabled={isReadOnly}
                        />
                    </div>
                    <div class="form-group">
                        <label>형식</label>
                        <input
                            type="text"
                            placeholder="입력"
                            bind:value={formData.fom}
                            disabled={isReadOnly}
                        />
                    </div>
                    <div class="form-group">
                        <label>차대번호(제조번호)</label>
                        <input
                            type="text"
                            placeholder="입력"
                            bind:value={formData.mnfctur_no}
                            disabled={isReadOnly}
                        />
                    </div>
                    <div class="form-group">
                        <label>품목코드</label>
                        <input
                            type="text"
                            placeholder="품목코드"
                            bind:value={formData.item_code}
                            disabled
                        />
                    </div>
                    <div class="form-group">
                        <label>품목명</label>
                        <input
                            type="text"
                            placeholder="품목명"
                            bind:value={formData.item_nm}
                            disabled
                        />
                    </div>
                    <div class="form-group required">
                        <label>판정</label>
                        <select bind:value={verdict} disabled={isReadOnly}>
                            <option value="적합">✅ 적합 (Pass)</option>
                            <option value="부적합">❌ 부적합 (Fail)</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>모델명</label>
                        <input
                            type="text"
                            placeholder="입력"
                            bind:value={formData.modl_no}
                            disabled={isReadOnly}
                        />
                    </div>
                    <div class="form-group">
                        <label>비고</label>
                        <input
                            type="text"
                            placeholder="입력"
                            bind:value={formData.rm}
                            disabled={isReadOnly}
                        />
                    </div>
                    <div class="form-group">
                        <label>규격</label>
                        <input
                            type="text"
                            placeholder="입력"
                            bind:value={formData.stndrd}
                            disabled
                        />
                    </div>
                </div>
            </section>

            <section class="section-card">
                <div class="section-header">
                    <h2 class="section-title">▣ 상세내역</h2>
                    {#if !isReadOnly}
                        <div style="display: flex; gap: 8px;">
                            <button
                                class="btn btn-secondary btn-sm"
                                on:click={addItem}
                            >
                                <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="3"
                                >
                                    <path d="M12 5v14M5 12h14" />
                                </svg>
                                항목추가
                            </button>
                            <button
                                class="btn btn-secondary btn-sm"
                                style="background-color: white; color: #6c757d; border-color: #6c757d;"
                                on:click={deleteSelectedItems}
                            >
                                🗑️ 삭제
                            </button>
                        </div>
                    {/if}
                </div>
                <div class="table-container">
                    <table class="detail-table">
                        <thead>
                            <tr>
                                <th width="50px">NO</th>
                                <th width="120px">공정번호</th>
                                <th width="150px">공정명</th>
                                <th width="120px">검사항목(구분)</th>
                                <th width="200px">검사항목</th>
                                <th width="120px">검사방법</th>
                                <th width="80px">주요항목</th>
                                <th width="300px">검사기준</th>
                                <th width="100px">판정</th>
                                <th width="100px">불량관리</th>
                                <th width="200px">비고</th>
                                <th width="60px">삭제</th>
                            </tr>
                        </thead>
                        <tbody>
                            {#each detailItems as item, idx (item.id)}
                                <tr
                                    on:click={(e) =>
                                        toggleRowSelection(e, item)}
                                    class:selected-row={item.delchk === "Y"}
                                >
                                    <td class="text-center">{idx + 1}</td>
                                    <td
                                        ><input
                                            type="text"
                                            class="table-input"
                                            bind:value={item.procs_no}
                                            disabled={isReadOnly}
                                        /></td
                                    >
                                    <td
                                        ><input
                                            type="text"
                                            class="table-input"
                                            bind:value={item.procs_nm}
                                            disabled={isReadOnly}
                                        /></td
                                    >
                                    <td>
                                        <select
                                            class="table-select"
                                            bind:value={item.inspct_iem_se_code}
                                            disabled={isReadOnly}
                                        >
                                            <option value="">선택</option>
                                            {#each inspctIemSeCodes as code}
                                                <option value={code.REFRN_CODE}
                                                    >{code.REFRN_NM}</option
                                                >
                                            {/each}
                                        </select>
                                    </td>
                                    <td
                                        ><input
                                            type="text"
                                            class="table-input"
                                            bind:value={item.inspct_iem}
                                            disabled={isReadOnly}
                                        /></td
                                    >
                                    <td>
                                        <select
                                            class="table-select"
                                            bind:value={item.inspct_mth_code}
                                            disabled={isReadOnly}
                                        >
                                            <option value="">선택</option>
                                            {#each inspctMthCodes as code}
                                                <option value={code.REFRN_CODE}
                                                    >{code.REFRN_NM}</option
                                                >
                                            {/each}
                                        </select>
                                    </td>
                                    <td>
                                        <select
                                            class="table-select"
                                            bind:value={item.main_iem_at}
                                            disabled={isReadOnly}
                                        >
                                            <option value="Y">Y</option>
                                            <option value="N">N</option>
                                        </select>
                                    </td>
                                    <td
                                        ><input
                                            type="text"
                                            class="table-input"
                                            bind:value={item.inspct_stdr}
                                            disabled={isReadOnly}
                                        /></td
                                    >
                                    <td>
                                        <select
                                            class="table-select"
                                            bind:value={item.prpert_at}
                                            disabled={isReadOnly}
                                        >
                                            <option value="Y">적합</option>
                                            <option value="N">부적합</option>
                                        </select>
                                    </td>
                                    <td class="text-center">
                                        {#if item.prpert_at === "N"}
                                            <button
                                                class="btn {isReadOnly
                                                    ? 'btn-info'
                                                    : 'btn-danger'}"
                                                on:click={(e) => {
                                                    e.stopPropagation();
                                                    selectedDefect = item;
                                                    if (
                                                        !selectedDefect.defects ||
                                                        selectedDefect.defects
                                                            .length === 0
                                                    )
                                                        selectedDefect.defects =
                                                            [
                                                                {
                                                                    id: Math.random()
                                                                        .toString(
                                                                            36,
                                                                        )
                                                                        .substr(
                                                                            2,
                                                                            9,
                                                                        ),
                                                                    delchk: "N",
                                                                    defectType:
                                                                        "",
                                                                    defectCause:
                                                                        "",
                                                                    defectContent:
                                                                        "",
                                                                    defectStatus:
                                                                        "미조치",
                                                                    defectRm:
                                                                        "",
                                                                    photos: [],
                                                                },
                                                            ];
                                                    selectedSubDefect = null;
                                                    isDefectPanelOpen = true;
                                                }}
                                                style="font-size: 11px; padding: 4px 8px; border-radius: 4px; font-weight: bold; border:none; background-color: {isReadOnly
                                                    ? '#17a2b8'
                                                    : '#dc3545'}; color: white; cursor: pointer;"
                                                >{isReadOnly
                                                    ? "조회"
                                                    : "등록"}</button
                                            >
                                        {/if}
                                    </td>
                                    <td
                                        ><input
                                            type="text"
                                            class="table-input"
                                            bind:value={item.rm}
                                            disabled={isReadOnly}
                                        /></td
                                    >
                                    <td class="text-center">
                                        {#if !isReadOnly}
                                            <button
                                                class="btn-delete-row"
                                                on:click={() =>
                                                    removeItem(item.id)}
                                                >✕</button
                                            >
                                        {/if}
                                    </td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                </div>
                {#if !isReadOnly}
                    <div class="bottom-add-container mt-3">
                        <button class="btn-bottom-add" on:click={addItem}>
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="3"
                            >
                                <path d="M12 5v14M5 12h14" />
                            </svg>
                            상세 항목 한줄 추가
                        </button>
                    </div>
                {/if}
            </section>
        </main>
        {#if selectedPhotoIndex !== null && photos[selectedPhotoIndex]}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <div class="zoom-overlay" on:click={closeZoom}>
                <div class="zoom-content" on:click|stopPropagation>
                    <button class="zoom-close" on:click={closeZoom}>×</button>
                    <button class="nav-btn prev" on:click={prevPhoto}>
                        <svg
                            width="40"
                            height="40"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="white"
                            stroke-width="2.5"><path d="m15 18-6-6 6-6" /></svg
                        >
                    </button>
                    <img
                        src={photos[selectedPhotoIndex].url}
                        alt={photos[selectedPhotoIndex].name}
                    />
                    <button class="nav-btn next" on:click={nextPhoto}>
                        <svg
                            width="40"
                            height="40"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="white"
                            stroke-width="2.5"><path d="m9 18 6-6-6-6" /></svg
                        >
                    </button>
                    <div class="zoom-caption">
                        <span class="photo-count"
                            >{selectedPhotoIndex + 1} / {photos.length}</span
                        >
                        <p class="zoom-info">
                            {photos[selectedPhotoIndex].name}
                        </p>
                    </div>
                </div>
            </div>
        {/if}

        <!-- Main File List Modal -->
        {#if isMainFileModalOpen}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <div
                class="zoom-overlay"
                on:click={() => (isMainFileModalOpen = false)}
                style="z-index: 1050; display: flex; justify-content: center; align-items: center; background-color: rgba(0, 0, 0, 0.5); position: fixed; top: 0; left: 0; width: 100%; height: 100%;"
            >
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <!-- svelte-ignore a11y-no-static-element-interactions -->
                <div class="modal-container" on:click|stopPropagation>
                    <div class="modal-header">
                        <h3>주내역 첨부파일 리스트</h3>
                        <button
                            class="modal-close"
                            on:click={() => (isMainFileModalOpen = false)}
                        >
                            ✕
                        </button>
                    </div>
                    {#if !isReadOnly}
                        <div class="modal-actions">
                            <button
                                class="btn btn-secondary btn-sm"
                                style="background-color: white; color: #495057; border-color: #ced4da;"
                                on:click={triggerMainCameraInput}
                            >
                                📷 카메라
                            </button>
                            <button
                                class="btn btn-secondary btn-sm"
                                style="background-color: white; color: #495057; border-color: #ced4da;"
                                on:click={triggerMainGalleryInput}
                            >
                                🖼️ 갤러리
                            </button>
                            <button
                                class="btn btn-secondary btn-sm"
                                style="background-color: white; color: #dc3545; border-color: #dc3545;"
                                on:click={deleteSelectedMainFiles}
                            >
                                🗑️ 파일삭제
                            </button>
                        </div>
                    {/if}
                    <div style="display:none;">
                        <input
                            type="file"
                            accept="image/*"
                            capture="environment"
                            bind:this={mainCameraInput}
                            on:change={handleMainFilesChange}
                        />
                        <input
                            type="file"
                            multiple="multiple"
                            bind:this={mainGalleryInput}
                            on:change={handleMainFilesChange}
                        />
                    </div>

                    <div class="table-container modal-body">
                        <table class="defect-table">
                            <thead>
                                <tr>
                                    <th width="50px">NO.</th>
                                    <th width="70px">미리보기</th>
                                    <th>파일명</th>
                                    <th>비고</th>
                                </tr>
                            </thead>
                            <tbody>
                                {#if mainFiles && mainFiles.length > 0}
                                    {#each mainFiles as file, idx (file.id)}
                                        <tr
                                            class={file.delchk === "Y"
                                                ? "selected-row"
                                                : ""}
                                            on:click={() => {
                                                if (!isReadOnly) {
                                                    file.delchk =
                                                        file.delchk === "Y"
                                                            ? "N"
                                                            : "Y";
                                                    mainFiles = mainFiles;
                                                }
                                            }}
                                        >
                                            <td class="text-center">
                                                {idx + 1}
                                            </td>
                                            <td class="text-center">
                                                <!-- If it is a previewable image, show thumbnail, else show document icon -->
                                                {#if file.url && (file.name || file.photo_nm || file.file_nm || "").match(/\.(jpg|jpeg|png|gif|bmp)$/i)}
                                                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                                                    <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
                                                    <img
                                                        src={file.url}
                                                        alt="preview"
                                                        style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px; cursor: pointer; border: 1px solid #ddd;"
                                                        on:click|stopPropagation={() =>
                                                            openImageZoom(
                                                                file.url,
                                                            )}
                                                    />
                                                {:else}
                                                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                                                    <!-- svelte-ignore a11y-no-static-element-interactions -->
                                                    <span
                                                        style="font-size: 24px; cursor: pointer;"
                                                        on:click|stopPropagation={() =>
                                                            openFile(
                                                                file.file,
                                                                file.serverData,
                                                            )}>📄</span
                                                    >
                                                {/if}
                                            </td>
                                            <td
                                                style="cursor: pointer; color: #007bff; text-decoration: underline;"
                                                on:click|stopPropagation={() =>
                                                    openFile(
                                                        file.file,
                                                        file.serverData,
                                                    )}
                                            >
                                                {file.name ||
                                                    file.photo_nm ||
                                                    file.orginlFileNm ||
                                                    file.fileNm ||
                                                    file.file_nm ||
                                                    "파일정보없음"}
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    class="table-input"
                                                    bind:value={file.rm}
                                                    disabled={isReadOnly}
                                                    on:click|stopPropagation
                                                    on:input={() =>
                                                        (mainFiles = mainFiles)}
                                                />
                                            </td>
                                        </tr>
                                    {/each}
                                {:else}
                                    <tr>
                                        <td
                                            colspan="4"
                                            class="text-center"
                                            style="padding: 20px 0; color: #999;"
                                        >
                                            등록된 첨부파일이 없습니다.
                                        </td>
                                    </tr>
                                {/if}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        {/if}
    {:else}
        <header class="top-bar">
            <div class="header-left">
                <button
                    class="icon-btn"
                    on:click={() => (isDefectPanelOpen = false)}
                >
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.5"><path d="m15 18-6-6 6-6" /></svg
                    >
                </button>
                <h1 class="title">불량관리</h1>
            </div>
        </header>
        <main
            class="content-scroll defect-page-main"
            style="padding: 0; display: flex; flex-direction: column; overflow: hidden;"
        >
            <div style="display: flex; flex-direction: column; height: 100%;">
                <div
                    class="panel-top"
                    style="padding: 8px 16px; background: #fff; border-bottom: 1px solid #ddd; flex-shrink: 0;"
                >
                    <h3
                        style="margin: 0 0 6px 0; font-size: 14px; color: #333;"
                    >
                        상세내역 정보
                    </h3>
                    <table class="defect-table">
                        <thead
                            ><tr
                                ><th style="padding: 4px 10px;">검사항목</th><th
                                    style="padding: 4px 10px;">검사기준</th
                                ></tr
                            ></thead
                        >
                        <tbody
                            ><tr
                                ><td
                                    class="text-center"
                                    style="padding: 4px 10px;"
                                    ><strong
                                        >{selectedDefect?.inspct_iem ||
                                            "-"}</strong
                                    ></td
                                ><td
                                    class="text-center"
                                    style="padding: 4px 10px;"
                                    >{selectedDefect?.inspct_stdr || "-"}</td
                                ></tr
                            ></tbody
                        >
                    </table>
                </div>
                <div
                    class="panel-middle"
                    style="flex: 1; padding: 16px; background: #f8f9fa; border-bottom: 1px dashed #ccc; display: flex; flex-direction: column; overflow: hidden;"
                >
                    <div
                        style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;"
                    >
                        <h3 style="margin: 0; font-size: 16px; color: #dc3545;">
                            불량(부적합) 리스트
                        </h3>
                        {#if !isReadOnly}
                            <div style="display: flex; gap: 8px;">
                                <button
                                    class="btn btn-sm"
                                    style="background-color: #ff4d4f; color: white; border: none; font-weight: bold; border-radius: 6px; padding: 6px 12px; box-shadow: 0 2px 4px rgba(255, 77, 79, 0.2);"
                                    on:click={addDefectRow}>➕ 불량추가</button
                                >
                                <button
                                    class="btn btn-sm"
                                    style="background-color: #6c757d; color: white; border: none; font-weight: bold; border-radius: 6px; padding: 6px 12px; box-shadow: 0 2px 4px rgba(108, 117, 125, 0.2);"
                                    on:click={deleteSelectedDefectRows}
                                    >🗑️ 불량삭제</button
                                >
                            </div>
                        {/if}
                    </div>
                    <div
                        class="table-container"
                        style="flex: 1; overflow-y: auto;"
                    >
                        <table class="defect-table">
                            <thead
                                ><tr
                                    ><th width="50px">선택</th><th>불량유형</th
                                    ><th>불량원인</th><th>불량내용</th><th
                                        width="120px">조치여부</th
                                    ><th>비고</th><th width="80px">사진확인</th
                                    ></tr
                                ></thead
                            >
                            <tbody>
                                {#if selectedDefect && selectedDefect.defects && selectedDefect.defects.length > 0}
                                    {#each selectedDefect.defects as defect (defect.id)}
                                        <tr
                                            class:selected-row={defect.delchk ===
                                                "Y"}
                                            on:click={() => {
                                                selectedSubDefect = defect;
                                            }}
                                        >
                                            <td class="text-center"
                                                ><input
                                                    type="checkbox"
                                                    checked={defect.delchk ===
                                                        "Y"}
                                                    disabled={isReadOnly}
                                                    on:click|stopPropagation
                                                    on:change={(e) => {
                                                        defect.delchk = e.target
                                                            .checked
                                                            ? "Y"
                                                            : "N";
                                                        detailItems =
                                                            detailItems;
                                                    }}
                                                /></td
                                            >
                                            <td>
                                                <select
                                                    class="table-select"
                                                    bind:value={
                                                        defect.defectType
                                                    }
                                                    disabled={isReadOnly}
                                                    on:click|stopPropagation
                                                >
                                                    <option value=""
                                                        >선택</option
                                                    >
                                                    {#each defectTypes as code}<option
                                                            value={code.REFRN_CODE}
                                                            >{code.REFRN_NM}</option
                                                        >{/each}
                                                </select>
                                            </td>
                                            <td>
                                                <select
                                                    class="table-select"
                                                    bind:value={
                                                        defect.defectCause
                                                    }
                                                    disabled={isReadOnly}
                                                    on:click|stopPropagation
                                                >
                                                    <option value=""
                                                        >선택</option
                                                    >
                                                    {#each defectCauses as code}<option
                                                            value={code.REFRN_CODE}
                                                            >{code.REFRN_NM}</option
                                                        >{/each}
                                                </select>
                                            </td>
                                            <td
                                                ><input
                                                    type="text"
                                                    class="table-input"
                                                    bind:value={
                                                        defect.defectContent
                                                    }
                                                    disabled={isReadOnly}
                                                    on:click|stopPropagation
                                                /></td
                                            >
                                            <td class="text-center">
                                                {defect.defectStatus ||
                                                    "미조치"}
                                            </td>
                                            <td
                                                ><input
                                                    type="text"
                                                    class="table-input"
                                                    bind:value={defect.defectRm}
                                                    disabled={isReadOnly}
                                                    on:click|stopPropagation
                                                /></td
                                            >
                                            <td class="text-center">
                                                <button
                                                    class="btn btn-primary btn-sm"
                                                    style="font-size: 11px; padding: 4px 8px;"
                                                    on:click|stopPropagation={() => {
                                                        selectedSubDefect =
                                                            defect;
                                                        fetchDefectPhotos(
                                                            selectedDefect,
                                                            defect,
                                                        );
                                                        isPhotoModalOpen = true;
                                                    }}>사진확인</button
                                                >
                                            </td>
                                        </tr>
                                    {/each}
                                {:else}
                                    <tr
                                        ><td
                                            colspan="7"
                                            class="text-center"
                                            style="padding: 40px; color: #999;"
                                            >등록된 불량 내역이 없습니다.</td
                                        ></tr
                                    >
                                {/if}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </main>

        {#if isPhotoModalOpen && selectedSubDefect}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <div
                class="zoom-overlay"
                on:click={() => (isPhotoModalOpen = false)}
                style="z-index: 1050; display: flex; justify-content: center; align-items: center; background-color: rgba(0, 0, 0, 0.5); position: fixed; top: 0; left: 0; width: 100%; height: 100%;"
            >
                <div class="modal-container" on:click|stopPropagation>
                    <div class="modal-header">
                        <h3>불량(부적합) 사진 리스트</h3>
                        <button
                            class="modal-close"
                            on:click={() => (isPhotoModalOpen = false)}
                            >✕</button
                        >
                    </div>
                    {#if !isReadOnly}
                        <div class="modal-actions">
                            <button
                                class="btn btn-secondary btn-sm"
                                style="background-color: white; color: #495057; border-color: #ced4da;"
                                on:click={() =>
                                    triggerDefectCameraInput(
                                        selectedSubDefect.id,
                                    )}>📷 카메라</button
                            >
                            <button
                                class="btn btn-secondary btn-sm"
                                style="background-color: white; color: #495057; border-color: #ced4da;"
                                on:click={() =>
                                    triggerDefectFileInput(
                                        selectedSubDefect.id,
                                    )}>🖼️ 갤러리</button
                            >
                            <button
                                class="btn btn-secondary btn-sm"
                                style="background-color: white; color: #dc3545; border-color: #dc3545;"
                                on:click={deleteSelectedDefectPhotos}
                                >🗑️ 사진삭제</button
                            >
                        </div>
                    {/if}
                    <div style="display:none;">
                        <input
                            type="file"
                            accept="image/*"
                            capture="environment"
                            id="camera_defect_{selectedSubDefect.id}"
                            on:change={(e) =>
                                handleDefectFileChange(e, selectedSubDefect)}
                        />
                        <input
                            type="file"
                            accept="image/*"
                            multiple="multiple"
                            id="file_defect_{selectedSubDefect.id}"
                            on:change={(e) =>
                                handleDefectFileChange(e, selectedSubDefect)}
                        />
                    </div>
                    <div class="table-container modal-body">
                        <table class="defect-table">
                            <thead
                                ><tr
                                    ><th width="50px">NO.</th><th width="70px"
                                        >미리보기</th
                                    ><th>사진명</th><th>비고</th></tr
                                ></thead
                            >
                            <tbody>
                                {#if selectedSubDefect.photos && selectedSubDefect.photos.length > 0}
                                    {#each selectedSubDefect.photos as photo, idx (photo.id)}
                                        <tr
                                            class:selected-row={photo.delchk ===
                                                "Y"}
                                            on:click={() => {
                                                if (!isReadOnly) {
                                                    photo.delchk =
                                                        photo.delchk === "Y"
                                                            ? "N"
                                                            : "Y";
                                                    detailItems = detailItems;
                                                }
                                            }}
                                        >
                                            <td class="text-center"
                                                >{idx + 1}</td
                                            >
                                            <td class="text-center">
                                                <img
                                                    src={photo.url}
                                                    alt="defect"
                                                    style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px; cursor: pointer; border: 1px solid #ddd;"
                                                    on:click|stopPropagation={() =>
                                                        openImageZoom(
                                                            photo.url,
                                                        )}
                                                />
                                            </td>
                                            <td
                                                style="cursor: pointer; color: #007bff; text-decoration: underline;"
                                                >{photo.name}</td
                                            >
                                            <td
                                                ><input
                                                    type="text"
                                                    class="table-input"
                                                    bind:value={photo.rm}
                                                    disabled={isReadOnly}
                                                    on:click|stopPropagation
                                                    on:input={() =>
                                                        (detailItems =
                                                            detailItems)}
                                                /></td
                                            >
                                        </tr>
                                    {/each}
                                {:else}
                                    <tr
                                        ><td
                                            colspan="4"
                                            class="text-center"
                                            style="padding: 40px; color: #999;"
                                            >등록된 사진이 없습니다.</td
                                        ></tr
                                    >
                                {/if}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        {/if}
    {/if}

    {#if isImageZoomOpen}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            class="zoom-overlay"
            on:click={() => (isImageZoomOpen = false)}
            style="z-index: 1100;"
        >
            <div
                class="zoom-content"
                on:click|stopPropagation
                on:touchstart|nonpassive={handleTouchStart}
                on:touchmove|nonpassive={handleTouchMove}
                on:touchend={handleTouchEnd}
                on:touchcancel={handleTouchEnd}
            >
                <button
                    class="zoom-close"
                    on:click={() => (isImageZoomOpen = false)}>✕</button
                >
                <img
                    src={zoomedImageUrl}
                    alt="zoomed"
                    style="transform: translate({zoomTx}px, {zoomTy}px) scale({zoomScale}); transition: transform {isDragging ||
                    initialPinchDistance !== null
                        ? '0s'
                        : '0.2s'}; transform-origin: center; max-width: 100%; max-height: 100%;"
                />
            </div>
        </div>
    {/if}
</div>

<style>
    .detail-page-container {
        display: flex;
        flex-direction: column;
        flex: 1;
        background-color: var(--bg-color, #f8f9fa);
        overflow: hidden;
    }
    .top-bar {
        background-color: white;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 20px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        z-index: 10;
        flex-shrink: 0;
    }
    .header-left {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .title {
        font-size: 18px;
        font-weight: 700;
        color: var(--text-main, #333);
        margin: 0;
    }
    .header-right {
        display: flex;
        align-items: center;
    }
    .icon-btn {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--text-main, #333);
        transition: background-color 0.2s;
        border: none;
        background: transparent;
        cursor: pointer;
    }
    .icon-btn:hover {
        background-color: var(--bg-color, #f8f9fa);
    }
    .btn-save {
        padding: 8px 16px;
        font-weight: 700;
        border-radius: 8px;
        display: flex;
        gap: 6px;
        align-items: center;
        background-color: var(--primary-color, #007bff);
        color: white;
        border: none;
        cursor: pointer;
    }
    .btn-delete {
        padding: 8px 16px;
        font-weight: 700;
        border-radius: 8px;
        display: flex;
        gap: 6px;
        align-items: center;
        background-color: #ef4444;
        color: white;
        border: none;
        cursor: pointer;
        margin-right: 8px;
        transition: background-color 0.2s, opacity 0.2s;
    }
    .btn-delete:hover {
        background-color: #dc2626;
    }
    .btn-delete.disabled {
        background-color: #d1d5db;
        color: #9ca3af;
        cursor: pointer;
    }
    .btn-delete.disabled:hover {
        background-color: #d1d5db;
    }
    .content-scroll {
        flex: 1;
        overflow-y: auto;
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
    .section-card {
        background-color: white;
        border-radius: 8px;
        padding: 16px 20px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
    .section-title {
        font-size: 15px;
        font-weight: 700;
        margin-bottom: 12px;
        color: var(--primary-color, #007bff);
        display: flex;
        align-items: center;
    }
    .form-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 12px 16px;
    }
    .form-group label {
        display: block;
        font-size: 13px;
        color: #666;
        margin-bottom: 6px;
        font-weight: 600;
    }
    .form-group input,
    .form-group select {
        width: 100%;
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 6px;
        font-size: 14px;
        box-sizing: border-box;
    }
    .required label::after {
        content: "*";
        color: #dc3545;
        margin-left: 4px;
    }
    .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
    }
    .table-container {
        width: 100%;
        overflow-x: auto;
    }
    .detail-table {
        width: 100%;
        border-collapse: collapse;
        min-width: 1600px;
        font-size: 13px;
    }
    .detail-table th,
    .detail-table td {
        border: 1px solid #dee2e6;
        padding: 6px 8px;
        vertical-align: middle;
    }
    .detail-table th {
        background-color: #f8f9fa;
        font-weight: 700;
        color: #495057;
        text-align: center;
    }
    .detail-table tr {
        cursor: pointer;
        transition: background-color 0.2s;
    }
    .detail-table tr:hover {
        background-color: #f8f9fa;
    }
    .detail-table tr.selected-row {
        background-color: #e6f2ff;
    }
    .text-center {
        text-align: center;
    }
    .table-input,
    .table-select {
        width: 100%;
        padding: 4px 6px;
        border: 1px solid #ced4da;
        border-radius: 4px;
        font-size: 13px;
        box-sizing: border-box;
    }
    .btn-delete-row {
        background: #ffe3e3;
        color: #fa5252;
        border: none;
        border-radius: 4px;
        width: 24px;
        height: 24px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 14px;
        font-weight: bold;
    }
    .bottom-add-container {
        margin-top: 24px;
        display: flex;
        justify-content: center;
    }
    .btn-bottom-add {
        width: 100%;
        max-width: 400px;
        padding: 14px;
        background-color: #f8f9fa;
        border: 2px dashed #ccc;
        border-radius: 12px;
        color: #666;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        transition: all 0.2s;
        cursor: pointer;
    }
    .btn-bottom-add:hover {
        background-color: #e8eaf6;
        border-color: #007bff;
        color: #007bff;
    }
    .defect-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 13px;
        background: #fff;
    }
    .defect-table th,
    .defect-table td {
        border: 1px solid #dee2e6;
        padding: 8px 10px;
        vertical-align: middle;
    }
    .defect-table th {
        background-color: #f8f9fa;
        font-weight: 700;
        text-align: center;
        color: #495057;
    }
    .defect-table tr.selected-row td {
        background-color: #ffe3e3 !important;
        border-color: #ffc9c9;
    }
    .zoom-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
    }
    .zoom-content {
        position: relative;
        max-width: 90vw;
        max-height: 90vh;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .zoom-content img {
        max-width: 100%;
        max-height: 80vh;
        object-fit: contain;
    }
    .zoom-close {
        position: absolute;
        top: -40px;
        right: 0;
        background: none;
        border: none;
        color: white;
        font-size: 30px;
        cursor: pointer;
    }
    .modal-container {
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
        width: 95%;
        max-width: 800px;
        height: 80vh;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
    .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 20px;
        background: #f8f9fa;
        border-bottom: 1px solid #e9ecef;
    }
    .modal-header h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
        color: #333;
    }
    .modal-close {
        background: none;
        border: none;
        font-size: 24px;
        color: #adb5bd;
        cursor: pointer;
        line-height: 1;
        padding: 0;
    }
    .modal-actions {
        padding: 12px 20px;
        display: flex;
        gap: 8px;
        justify-content: flex-end;
        border-bottom: 1px solid #e9ecef;
        background: #fff;
    }
    .modal-body {
        flex: 1;
        overflow-y: auto;
        padding: 0;
        background: #f8f9fa;
    }
    .nav-btn {
        background: none;
        border: none;
        cursor: pointer;
        padding: 20px;
    }
    .zoom-caption {
        position: absolute;
        bottom: -40px;
        color: white;
        text-align: center;
        width: 100%;
    }

    .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(255, 255, 255, 0.75);
        backdrop-filter: blur(2px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 9999;
    }
    .loading-spinner {
        width: 50px;
        height: 50px;
        border: 4px solid #f3f3f3;
        border-top: 4px solid #3b82f6;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin-bottom: 16px;
    }
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
    .loading-overlay p {
        font-size: 1rem;
        font-weight: 700;
        color: #1e293b;
    }
</style>
